import { fn } from '@ember/helper';
import and from 'ember-truth-helpers/helpers/and';
import not from 'ember-truth-helpers/helpers/not';
import BvText from 'volta/components/bv-text';
import BvInline from 'volta/components/bv-inline';
import BvDndHandle from 'volta/components/bv-dnd/handle';
import BvTag from 'volta/components/bv-tag';
import sortableGroup from 'ember-sortable/modifiers/sortable-group';
import sortableItem from 'ember-sortable/modifiers/sortable-item';
import type { ICollectionGroupOption } from 'volta/models/types/collection-view';
import type { TOC } from '@ember/component/template-only';

interface CollectionViewGroupTagsSignature {
  Args: {
    groups: ICollectionGroupOption[];
    onReorder: (options: ICollectionGroupOption[], draggedOption?: ICollectionGroupOption) => void;
    onRemoveGroup: (group: ICollectionGroupOption) => void;
    isGroupMin?: boolean;
  };
  Element: HTMLDivElement;
  Blocks: {
    default: [];
  };
}

const groupName = 'CollectionViewGroupTags';

const CollectionViewGroupTags: TOC<CollectionViewGroupTagsSignature> = <template>
  <BvInline
    @blockAlign='center'
    class='collection-view-group-tags'
    {{sortableGroup onChange=@onReorder direction='x' groupName=groupName}}
    ...attributes
  >
    {{#each @groups key='value' as |group|}}
      <div class='u-m-05' {{sortableItem model=group groupName=groupName}}>
        <BvTag
          @text={{group.label}}
          @color={{group.color}}
          @onRemove={{if (and (not @isGroupMin) group.editable) (fn @onRemoveGroup group)}}
          class='u-pl-05'
        >
          <BvInline @gap='1' @blockAlign='center'>
            <BvDndHandle @direction='x' @disabled={{not group.editable}} @color={{group.color}} />
            <BvText @text={{group.label}} />
          </BvInline>
        </BvTag>
      </div>
    {{/each}}
  </BvInline>
</template>;

export default CollectionViewGroupTags;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'CollectionView::GroupTags:': typeof CollectionViewGroupTags;
    'collection-view/group-tags': typeof CollectionViewGroupTags;
  }
}
